import styled from 'styled-components'

const privateStyle = isPrivate => {
  if (isPrivate) { return 'margin-bottom: 64px' }

  return `
    @media screen and (max-width: 575px) {
      position: relative;
      bottom: 0;
    }
  `
}

export const Container = styled.div`
  background: #F8F9FA;
  padding: 24px 16px;
  display:flex;
  flex-direction:column;
  align-items:center;
  color:#fff;
  ${({ privateRoute }) => privateStyle(privateRoute)};
  margin-top: auto;
  @media(min-width: 991px) {
    align-items: flex-start;
    margin-bottom: 0;
  }
`
export const GroupLogo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  span {
    font-family: 'Open Sans';
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    color: #555;
  }
`
export const Logo = styled.img`
  height: 32px;
`
export const Text = styled.div`
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  color: #555;
  margin-top: 24px;
`
export const Link = styled.button`
  font-family: 'Open Sans', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 19px;
  letter-spacing: 0.96px;
  color: #028BB7;
  background-color: transparent;
  border: none;
  margin-top: 16px;
  align-self: start;
`
